module.exports = __webpack_public_path__ + "static/media/exit-bunker-shot-card.c99075d1.png";